export const formatSeconds = (seconds: number) => {
	return (
		Math.floor((seconds - (seconds %= 60)) / 60) + (9 < seconds ? ":" : ":0") + Math.floor(seconds)
	);
};
